import React from 'react'
import { Link } from 'gatsby'
import APIRefBlockSwagger from './APIRefBlockSwagger'

export default function Parameters({
  headerParameters,
  pathParameters,
  formDataParameters,
  queryParameters,
  cleanedRequestBody,
  opAnchor,
}) {
  return (
    <div className="dax-reference-set dx-flex">
      <div className="dax-reference">
        <APIRefBlockSwagger
          opName={opAnchor}
          transaction="queryParameters"
          transactionTitle="Query parameters"
          transactionId="query-parameters"
          block="request"
          parameters={queryParameters}
        />

        <APIRefBlockSwagger
          opName={opAnchor}
          transaction="headerParameters"
          transactionTitle="Header parameters"
          transactionId="header-parameters"
          block="request"
          parameters={headerParameters}
        />

        <APIRefBlockSwagger
          opName={opAnchor}
          transaction="formParameters"
          transactionTitle="Form parameters"
          transactionId="form-parameters"
          block="request"
          parameters={formDataParameters}
        />

        <APIRefBlockSwagger
          opName={opAnchor}
          transaction="pathParameters"
          transactionTitle="Path parameters"
          transactionId="path-parameters"
          block="request"
          parameters={pathParameters}
        />

        <APIRefBlockSwagger
          opName={opAnchor}
          transaction="requestBody"
          transactionTitle="Request body"
          transactionId="request-body"
          block="request"
          parameters={cleanedRequestBody}
        />
      </div>
    </div>
  )
}
